var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.datetime)?_c('b-tooltip',{attrs:{"label":_vm.unitDatetime,"position":"is-left","type":"is-dark","multilined":""}},[_vm._v(" "+_vm._s(_vm.timeAgoText)+" ")]):_c('span',[_vm._v("-")])}
var staticRenderFns = []

export { render, staticRenderFns }